import script from "./StyleSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./StyleSetting.vue?vue&type=script&setup=true&lang=js"

import "./StyleSetting.vue?vue&type=style&index=0&id=529fde81&lang=scss&scoped=true"

import exportComponent from "/Users/zhangyi/WebstormProjects/aigc-poc-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529fde81"]])

export default __exports__